import { useIntl } from 'react-intl'

import logo_cs from '../../assets/img/logo-web-02-bila.png?format=webp'
import logo_en from '../../assets/img/logo-web-02-bila.png?format=webp'

export const useLogo = () => {
    const intl = useIntl()

    return intl.locale === 'cs-CZ' ? logo_cs : logo_en
}